var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 19V5C19 3.34315 17.6569 2 16 2H8C6.34315 2 5 3.34315 5 5V19C5 20.6569 6.34315 22 8 22H16C17.6569 22 19 20.6569 19 19ZM12.71 18.71C12.9937 18.4224 13.0766 17.9924 12.92 17.62C12.8714 17.4917 12.8003 17.3732 12.71 17.27C12.6625 17.227 12.6124 17.1869 12.56 17.15C12.5043 17.1122 12.4437 17.0819 12.38 17.06L12.2 17C11.8671 16.9362 11.5246 17.0454 11.29 17.29C11.199 17.3851 11.1276 17.4972 11.08 17.62C10.9313 17.9915 11.0184 18.4158 11.3013 18.6987C11.5842 18.9816 12.0085 19.0687 12.38 18.92C12.5012 18.8694 12.6128 18.7983 12.71 18.71ZM17 5C17 4.44772 16.5523 4 16 4H8C7.44772 4 7 4.44772 7 5V19C7 19.5523 7.44772 20 8 20H16C16.5523 20 17 19.5523 17 19V5ZM11 5H13.12H13.14C13.6923 5 14.14 5.44772 14.14 6C14.14 6.55228 13.6923 7 13.14 7H11C10.4477 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.797b00283d2938a6a9af513354ec2dce.svg";
export { ForwardRef as ReactComponent };